<template>
    <div class="buttom">
        <!--<div style="height: 100px"></div>-->
        <div class="buttom_xiam">
            <div class="buttom_zhuban" v-if="dangwei!=''">网站主办单位：{{dangwei}}</div>
            <div class="buttom_zhuban">
                <span v-if="biaoshi!=''">网站标识码：{{biaoshi}}</span>
                <a style="color: #fff;text-decoration: underline;" href="https://beian.miit.gov.cn/" target="_blank" v-if="jingbei!=''">豫ICP备{{jingbei}}</a>
                <a style="color: #fff;text-decoration: underline;" href="https://beian.miit.gov.cn/" target="_blank" v-if="beian!=''">豫公网安备{{beian}} 号</a>
            </div>
            <div class="buttom_zhuban" v-if="bianq!=''">{{bianq}}版权所有，如需转载，请注明来源 </div>
            <div class="buttom_zhuban" v-if="company!=''">技术支持单位：{{company}}</div>
        </div>

    </div>
</template>

<script>
    import Http from "../https";
    export default {
        name: "buttons",
        data () {
            return {
                dangwei:"",
                biaoshi:"",
                jingbei:"",
                beian:"",
                bianq:"",
                company:""
            }
        },
        created(){
            this.buttonmet()
        },
        methods:{
            buttonmet(){
                Http.fetchPost("index/buttom").then((data)=>{
                    let result=data.data
                    console.log("buuton:",result)
                    if (result.code==1){
                        this.dangwei=result.data.sponsor.trim()
                        this.biaoshi=result.data.identifier.trim()
                        this.jingbei=result.data.icp.trim()
                        this.beian=result.data.public.trim()
                        this.bianq=result.data.copyright.trim()
                        this.company=result.data.technology.trim()
                    } else {
                        this.$message.error(result.msg);
                    }
                }).then((err)=>{
                    // this.$message.error('服务器繁忙');
                    // return ;
                })
            }
        }
    }
</script>

<style scoped>
    .buttom_zhuban{
        text-align: center;
        color: white;
        font-size: 18px;
        margin-bottom: 4px;
    }
    .buttom_xiam{
        width: 1064px;
        min-width: 1064px;
        margin: 0 auto;
        text-align: center;
        margin-top: 38px;
        font-size: 18px;
    }
    .buttom{
        padding-top: 5px;
        height: 202px;
        line-height: 30px;
        width: 100%;
        /*background-image: url("https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg");*/
        /*background-image: url("/static/image/ban_bg.png");*/
        /*border-top: 1px solid #ddd;*/
        background:linear-gradient(225deg,rgba(51,180,210,1) 0%,rgba(29,43,176,1) 100%);
        text-align: center;
        font-size: 18px;
    }
</style>



// WEBPACK FOOTER //
// src/components/buttons.vue